import { createAuthClient } from 'better-auth/react';
import { inferAdditionalFields } from 'better-auth/client/plugins';
import { clientPlugins, basePath } from '@repo/api/auth/client';
import type { ToroAuth } from '@repo/backend-types/auth-api';
import type { BetterAuthClientOptions } from 'better-auth/types';

export const clientAuthOptions = {
  basePath,
  plugins: [...clientPlugins, inferAdditionalFields<ToroAuth>()],
} as const satisfies BetterAuthClientOptions;

// Client-side auth client that is routed through our next.js proxy
export const authClient = createAuthClient(clientAuthOptions);
export default authClient;

export const { useSession } = authClient;

export type Session = typeof authClient.$Infer.Session;
